import { useTrilogyContext } from '../context';
/**
 * Used to hash classes if styled components
 * @param styled Apply only if styled props
 * @param classes String classes
 */
export var hashClass = function (addHash, classes) {
    if (addHash === void 0) { addHash = false; }
    var _a = useTrilogyContext(), hash = _a.hash, styled = _a.styled;
    if (classes.trim().length < 1)
        return '';
    if (styled) {
        return classes
            .split(' ')
            .map(function (classe) { return (classe = "".concat(classe, "_").concat(hash)); })
            .join(' ');
    }
    return classes;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGFzaENsYXNzZXNIZWxwZXJzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vaGVscGVycy9oYXNoQ2xhc3Nlc0hlbHBlcnMudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxpQkFBaUIsRUFBRSxNQUFNLFdBQVcsQ0FBQTtBQUU3Qzs7OztHQUlHO0FBQ0gsTUFBTSxDQUFDLElBQU0sU0FBUyxHQUFHLFVBQUMsT0FBZSxFQUFFLE9BQWU7SUFBaEMsd0JBQUEsRUFBQSxlQUFlO0lBQ2pDLElBQUEsS0FBbUIsaUJBQWlCLEVBQUUsRUFBcEMsSUFBSSxVQUFBLEVBQUUsTUFBTSxZQUF3QixDQUFBO0lBRTVDLElBQUksT0FBTyxDQUFDLElBQUksRUFBRSxDQUFDLE1BQU0sR0FBRyxDQUFDO1FBQUUsT0FBTyxFQUFFLENBQUE7SUFDeEMsSUFBSSxNQUFNLEVBQUU7UUFDVixPQUFPLE9BQU87YUFDWCxLQUFLLENBQUMsR0FBRyxDQUFDO2FBQ1YsR0FBRyxDQUFDLFVBQUMsTUFBYyxJQUFLLE9BQUEsQ0FBQyxNQUFNLEdBQUcsVUFBRyxNQUFNLGNBQUksSUFBSSxDQUFFLENBQUMsRUFBOUIsQ0FBOEIsQ0FBQzthQUN2RCxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUE7S0FDYjtJQUNELE9BQU8sT0FBTyxDQUFBO0FBQ2hCLENBQUMsQ0FBQSJ9